/** Presentation only; the server gate independently redirects old entry points. */
const OLD_PAYROLL_DESTINATIONS = new Set([
  '/payroll/queue',
  '/payroll/readiness',
  '/payroll/setup',
  '/payroll/policy',
  '/payroll/provider-handoff',
  '/settings/payroll/aba-sender',
  '/settings/payroll/provider-responsibilities',
]);
export function isPayrollDiscoveryPathVisible(href: string, newPayroll = false) {
  return !newPayroll || !OLD_PAYROLL_DESTINATIONS.has(href.split('?')[0]?.split('#')[0] ?? href);
}
